<template>
  <div class="about-journey-wrapper">
    <div class="text-title-sm">{{ $t('about.journey.headTitle') }}</div>

    <div class="journey-items">
      <div v-for="(info, index) in ages" :key="index" class="journey-item">
        <div class="journey-item-container">
          <div class="journey-item-age">
            <div class="text-subtitle-xl text-subtitle-age">{{ info.year }}</div>
          </div>
          <div class="journey-item-content-wrapper">
            <div
              v-for="(tagList, key, featIndex) in info.feats"
              class="journey-item-content-container"
              :key="key">
              <div class="tag-list">
                <div
                  v-for="(item, tagIndex) in tagList"
                  class="tag-item text-content-desc-xsm"
                  :key="tagIndex">
                  {{ getProductName(item) }}
                </div>
              </div>
              <div class="text-subtitle-xl text-subtitle-journey-item">
                {{ $t(`about.journey.title${key}`) }}
              </div>
              <div class="text-content-desc-xsm">
                {{ $t(`about.journey.desc${key}`) }}
              </div>
              <br v-if="featIndex < Object.keys(info.feats).length - 1" />
            </div>
          </div>
        </div> <!-- journey-item-container -->
        <div class="seperator"></div>
      </div> <!-- for info, index -->
    </div> <!-- journey-items -->

  </div>
</template>
<script>
import productEnum from '../../enums/productEnum';

export default {
  name: 'about-journey',
  data() {
    return {
      ages: [
        { year: '2014', feats: { 2014: [productEnum.CAMERA] } },
        { year: '2015', feats: { 2015: [productEnum.CAMERA] } },
        { year: '2016', feats: { 2016: [productEnum.CAMERA] } },
        { year: '2017', feats: { 2017: [productEnum.CAMERA] } },
        { year: '2018', feats: { 2018: [productEnum.CAMERA] } },
        { year: '2019', feats: { 2019: [productEnum.CAMERA] } },
        { year: '2020', feats: { 2020: [productEnum.CAMERA] } },
        { year: '2021', feats: { 2021: [productEnum.TABLEWARE] } },
        { year: '2022', feats: { 2022: [productEnum.CAMERA] } },
        { year: '2023', feats: { 2023: [productEnum.CAMERA], '2023_1': [productEnum.CAMERA] } },
      ],
    };
  },
  methods: {
    getProductName(key) {
      switch (key) {
        case productEnum.CAMERA:
          return this.$t('about.product.camera');
        case productEnum.TABLEWARE:
          return this.$t('about.product.tableware');
        default:
          return this.$t('about.product.camera');
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.about-journey-wrapper
  --journey-item-width: 60vw
  color: $primary
  .journey-items
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    margin: 80px 0
    .journey-item
      display: flex
      flex-direction: column
      align-items: center
      margin-bottom: 8px
      .journey-item-container
        display: flex
        align-items: flex-start
        width: var(--journey-item-width)
        .journey-item-age
          margin-right: 56px
          .text-subtitle-age
            margin-top: -4px
        .journey-item-content-wrapper
          display: flex
          flex-direction: column
          align-items: flex-start
          text-align: left
          .journey-item-content-container
            .tag-list
              line-height: 1.5
              color: #D0D0D0
            .text-subtitle-journey-item
              font-weight: 700
              color: $lollipop-blue
      .seperator
        width: 1px
        height: 36px
        background-color: $primary
        margin: 40px 0
      &:last-child
        .seperator
          display: none

@media screen and (min-width: 1600px)
  .about-journey-wrapper
    --journey-item-width: 50vw

/** Mobile */
@media screen and (max-width: 768px)
  .about-journey-wrapper
    --journey-item-width: 75vw
    .journey-items
      margin: 48px 0px
      .journey-item
        .journey-item-container
          display: flex
          flex-direction: column
          align-items: center
          .journey-item-age
            margin-right: 0px
            .text-subtitle-age
              font-size: 24px
          .journey-item-content-wrapper
            display: flex
            flex-wrap: wrap
            align-items: center
            text-align: center

/** iPad Pro */
@media screen and (min-width: 960px) and (min-aspect-ratio: 3/5) and (max-aspect-ratio: 9/10)
  .about-journey-wrapper
    --journey-item-width: 70vw
    .journey-items
      margin: 80px 0
      .journey-item
        margin-bottom: 8px
</style>
